/** Dispara o middleware, revalidando regras no lado runtime do servidor. */
export async function runMiddleware() {
    const response = await fetch('/', {
        headers: {
            'x-refresh-token': 'true',
            'Cache-Control': 'no-cache',
            'User-Agent': 'FetchMiddlewareFromClient/1.0',
        }
    })

    return response
}